import { TransitionGroup } from 'react-transition-group';
import { useObservedValue, useActivityIndicator, CSSRefTransition, Throbber } from '@utils/react';
import { ThrobberVisibleState } from '../store.js';
import { wrapper, fadeDurationMs, throbber } from './atom.throbber.style.js';
import { jsx } from 'react/jsx-runtime';

function PrinterThrobber() {
  const isVisible = useObservedValue(ThrobberVisibleState);
  const showThrobber = useActivityIndicator(isVisible, {
    durationMs: 0,
    delayMs: 1_000
  });
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    appear: true,
    children: showThrobber.isActive() && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: fadeDurationMs,
      classNames: wrapper,
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: wrapper,
        children: /*#__PURE__*/jsx("div", {
          className: throbber,
          children: /*#__PURE__*/jsx(Throbber, {})
        })
      })
    })
  });
}

export { PrinterThrobber };
//# sourceMappingURL=atom.throbber.js.map
